export default "__VITE_ASSET__459ad3d7__"